import React, { Component } from 'react';
import themes from './themes';
import './App.css';

import TabBar      from './components/TabBar';
import ActivityBar from './components/ActivityBar';
import SideBar     from './components/SideBar';
import Syntax      from './components/Syntax';
import StatusBar   from './components/StatusBar';

class App extends Component {

  /**
   * Setup initial state.
   * @param {Object} props 
   */
  constructor(props) {
    super(props);
    this.state = this.getInitialState();

    if (window.location.hash) {
      const hash = window.location.hash.replace('#', '');
      if (this.state.themes[hash] !== undefined) {
        this.state.currentTheme = hash;
      }
    }

    window.onkeydown = e => {
      e = e || window.event;
      switch(e.keyCode) {
        case 67: {
          e.preventDefault();
          this.switchType('contrast');
          break;
        }
        case 76: {
          e.preventDefault();
          this.switchType('light');
          break;
        }
        case 78: {
          e.preventDefault();
          this.switchType('normal');
          break;
        }
        case 38: {
          e.preventDefault();
          this.previousTheme();
          break;
        }
        case 40: {
          e.preventDefault();
          this.nextTheme();
          break;
        }
        case 37: {
          e.preventDefault();
          this.previousLanguage();
          break;
        }
        case 39: {
          e.preventDefault();
          this.nextLanguage();
          break;
        }

        default: {
          break;
        }
      }
    };
  }

  /**
   * Get the initial state for this application.
   * @return {Object}
   */
  getInitialState() {
    // Build state.
    return {
      languages: {
        php:  'Container.php',
        html: 'index.html'
      },
      currentLanguage: 'php',
      themes:          themes,
      currentTheme:    Object.keys(themes)[2],
      types:           ['light', 'contrast', 'normal'],
      currentType:     'normal'
    }; 
  }

  /**
   * Switch the active language.
   * @param {string} language 
   */
  switchLanguage(language) {
    this.setState({currentLanguage: language});
  }

  /**
   * Switch the active theme.
   * @param {string} theme 
   */
  switchTheme(theme) {
    this.setState({currentTheme: theme});
    window.location.hash = theme;
  }

    /**
   * Switch the theme type filter.
   * @param {string} type 
   */
  switchType(type) {
    this.setState({currentType: type});
  }

  nextTheme() {
    let pick = false;

    for (const theme in this.getCurrentThemes()) {

      if (pick === true) {
        return this.switchTheme(theme);
      }

      if (theme === this.state.currentTheme) {
        pick = true;
      }
    }
  }

  previousTheme() {
    let previous = null;

    for (const theme in this.getCurrentThemes()) {
      if (theme === this.state.currentTheme) {
        if (previous !== null) {
          this.switchTheme(previous);
        }
      }
      previous = theme;
    }
  }

  nextLanguage() {
    let pick = false;

    for (const language in this.state.languages) {

      if (pick === true) {
        return this.switchLanguage(language);
      }

      if (language === this.state.currentLanguage) {
        pick = true;
      }
    }
  }

  previousLanguage() {
    let previous = null;

    for (const language in this.state.languages) {
      if (language === this.state.currentLanguage) {
        if (previous !== null) {
          this.switchLanguage(previous);
        }
      }
      previous = language;
    }
  }

  /**
   * Get the current active theme object.
   * @return {Object}
   */
  getActiveTheme() {

    let key = null;

    switch (this.state.currentType) {
      case 'light': {
        key = this.state.currentTheme + '-light';
        break;
      }
      case 'contrast': {
        key = this.state.currentTheme + '-contrast';
        break;
      }
      default: {
        key = this.state.currentTheme;
      }
    }

    if (this.state.themes[key] !== undefined) {
      return this.state.themes[key];
    }

    return this.state.themes[this.state.currentTheme];
  }

  /**
   * Get the themes for the current contrast mode.
   * @return {Object}
   */
  getCurrentThemes() {
    const themes = this.state.themes;
    const themesSubset = {};

    for (const key in themes) {
      const theme = themes[key];

      if (key.indexOf('contrast') > 0) {
        continue;
      } else if (key.indexOf('light') > 0) {
        continue;
      } else {
        themesSubset[key] = theme;
      }
    }

    return themesSubset;
  }

  /**
   * Render the component.
   * @return {HTML}
   */
  render() {
    // Create scoped references to simplify the JSX.
    const activeTheme = this.getActiveTheme();

    // Destructure the state.
    const {
      currentLanguage,
      languages,
      currentTheme,
      currentType
    } = this.state;

    // Bind functions.
    const switchLanguage = this.switchLanguage.bind(this);
    const switchTheme = this.switchTheme.bind(this);
    const switchType = this.switchType.bind(this);
    const filteredThemes = this.getCurrentThemes.bind(this);

    // Render the main application.
    return (
      <div style={{backgroundColor: activeTheme.background}} className={activeTheme.dark === false ? 'editor light' : 'editor'}>
        <ActivityBar current={currentType} switcher={switchType} />
        <SideBar theme={activeTheme} type={currentType} current={currentTheme} themes={filteredThemes()} switcher={switchTheme} />
        <TabBar current={currentLanguage} langs={languages} switcher={switchLanguage} />
        <Syntax current={currentLanguage} theme={activeTheme} />
        <StatusBar theme={activeTheme} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js